import { useEffect, useState, Fragment } from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import {
    Menu as ChakraMenu,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerBody,
    DrawerCloseButton,
    useDisclosure,
    Portal,
} from "@chakra-ui/react";
import {
    AiOutlineHeart,
    AiOutlineShoppingCart,
    AiOutlineUser,
    AiOutlineTag,
} from "react-icons/ai";
import { GrClose } from "react-icons/gr";
import { TbCertificate } from "react-icons/tb";
import { BiMenu } from "react-icons/bi";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { IoIosSearch } from "react-icons/io";
import { PiAddressBook, PiPhoneCallLight } from "react-icons/pi";
import { RiListCheck2 } from "react-icons/ri";
import { toast } from "react-toastify";

import NavLinks from "./NavLinks";
import SearchBox from "./SearchBox";
import CouponCard from "./CouponCard";
import Message from "./Message";

import { logout } from "../actions/userActions";
import { listSupportDetails } from "../actions/supportFaqActions";
import { getAllCoupons } from "../actions/couponActions";
import { getCartItems } from "../actions/cartActions";
import { getWishlistItems } from "../actions/wishListActions";
import {
    MdExpandLess,
    MdOutlineDashboardCustomize,
    MdOutlineLogout,
} from "react-icons/md";

import {
    Bars3Icon,
} from '@heroicons/react/24/outline'

import { UserMenu, IconLink } from "./UserMenu"
import "./style.css";

const NewHeader = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const isProductScreen = location.pathname.includes("/product");

    // const [open2, setOpen2] = useState(false);

    const messages = ['GET FLAT RS 150 CASHBACK ON 1ST MOBIKWIK UPI PAYMENT ON A MINIMUM SPEND OF RS 1,999',
        'CERTIFICATE OF AUTHENTICITY',
        'WARRANTY ON ALL PRODUCTS',
        'HALLMARKED PURE 925 STERLING SILVER',
        '25% OFF ON ALL PRODUCTS'
    ];

    const [index, setIndex] = useState(0);

    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [searchVisible, setSearchVisible] = useState(false);
    const [display, setDisplay] = useState("flex");
    const [drawerContent, setDrawerContent] = useState("");

    const { isOpen, onOpen, onClose } = useDisclosure();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;

    const wishList = useSelector((state) => state.wishlist);
    const { wishlistItems } = wishList;

    const { loading, error, categories } = useSelector(
        (state) => state.categoryList
    );

    const {
        loading: loadingSubCat,
        error: errorSubCat,
        subcategories,
    } = useSelector((state) => state.subCategoryList);

    const {
        loading: loadingColl,
        error: errorColl,
        collections,
    } = useSelector((state) => state.collectionList);

    const supportDetails = useSelector((state) => state.supportDetails);
    const {
        loading: loadingSupport,
        error: errorSupport,
        support,
    } = supportDetails;

    const userMenuItems = [
        { name: "Dashboard", icon: MdOutlineDashboardCustomize, href: "/dashboard", userMenu: false },
        { name: "Orders", icon: RiListCheck2, href: "/orders", userMenu: true },
        { name: "Addresses", icon: PiAddressBook, href: "/addresses", userMenu: true },
        { name: "Profile", icon: AiOutlineUser, href: "/profile", userMenu: true },
        { name: "My Warranty Claims", icon: TbCertificate, href: "/my-warranty-claims", userMenu: true },
        { name: "Coupons", icon: AiOutlineTag, href: "#", userMenu: true },
    ];

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const [localWishlistCount, setLocalWishlistCount] = useState(() => {
        if (!userInfo) {
            const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
            return localWishlist.length;
        }
        return 0;
    });

    const [localCartCount, setLocalCartCount] = useState(() => {
        if (!userInfo) {
            const localCartlist = JSON.parse(localStorage.getItem("savedCart")) || [];
            return localCartlist.length;
        }
        return 0;
    });

    useEffect(() => {
        dispatch(listSupportDetails());
        if (userInfo?.token) {
            dispatch(getAllCoupons());
            dispatch(getCartItems());
            dispatch(getWishlistItems());
            setLocalWishlistCount(0);
            setLocalCartCount(0);
        }
    }, [dispatch, userInfo]);

    // useEffect(() => {
    //     if (!userInfo) {
    //         const handleUpdate = () => {
    //             const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
    //             setLocalWishlistCount(localWishlist.length);
    //         };

    //         window.addEventListener("localWishlistUpdated", handleUpdate);

    //         // cleanup listener
    //         return () => {
    //             window.removeEventListener("localWishlistUpdated", handleUpdate);
    //         };
    //     }
    // });

    useEffect(() => {
        if (!userInfo) {
            const handleWishlistUpdate = () => {
                const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
                setLocalWishlistCount(localWishlist.length);
            };

            const handleCartUpdate = () => {
                const localCart = JSON.parse(localStorage.getItem("savedCart")) || [];
                setLocalCartCount(localCart.length);
            };

            window.addEventListener("localWishlistUpdated", handleWishlistUpdate);
            window.addEventListener("localCartUpdated", handleCartUpdate);

            // Cleanup listeners on unmount
            return () => {
                window.removeEventListener("localWishlistUpdated", handleWishlistUpdate);
                window.removeEventListener("localCartUpdated", handleCartUpdate);
            };
        }
    });


    useEffect(() => {
        location.pathname.split("/")[1] === `dashboard` ||
            location.pathname.split("/")[1] === "notifications" ||
            location.pathname.split("/")[1] === "payments"
            ? setDisplay("none")
            : setDisplay("flex");
    }, [location]);


    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % messages.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);



    const handleLogout = () => {
        dispatch(logout());
        toast.success(<RouterLink to="#">Thank you for visiting Sairah</RouterLink>);
        navigate("/");
    };

    const handleCouponsClick = () => {
        if (userInfo?.token) {
            dispatch(getAllCoupons()); // call API only when drawer opens
        }
        setDrawerContent("coupons");
        onOpen();
    };

    const logoutHandler = () => {
        dispatch(logout());
        notify("#", "Thank you for visiting Sairah", toast.success);
        setMobileMenuOpen(false);
        navigate("/");
    };

    const notify = (link, content, type) =>
        type(<RouterLink to={link}>{content}</RouterLink>);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const totalCartItems = cartItems?.reduce((acc, item) => acc + item.qty, 0) || 0;


    return (
        <div>

            {/* Accessible Hidden Titles */}
            <h1 className="sr-only">Real Silver jewellery, online silver jewellery store...</h1>
            <h2 className="sr-only">Silver jewellery store.</h2>

            {/* Scroll To Top Button */}
            {scrolled && (
                <button
                    className="fixed bottom-16 right-4 text-white rounded-full z-40"
                    onClick={scrollToTop}
                >
                    <img
                        src="https://d1lfl311x81a6w.cloudfront.net/products/1730092303188.png"
                        alt="Go To Top"
                        loading="lazy"
                        width="12"
                        height="12"
                        className="h-12 w-12 p-1 ml-6 rounded-full"
                    />
                </button>
            )}

            {!isProductScreen && (<div className={`w-full bg-[#000080] text-white text-sm font-medium py-2 px-4 flex justify-center items-center ${index == 0 ? "" : ""}`}>
                <div className={`transition-opacity duration-500 ease-in-out ${index === 0 ? "text-center" : ""}`}>
                    {messages[index]}
                </div>
            </div>)}

            <header
                className={`w-full bg-white ${display === "none" ? "hidden" : "flex"} flex-col transition-shadow duration-300 z-30 top-0 ${scrolled ? "fixed  shadow-md" : "relative"
                    }`}
                style={{ WebkitTransform: "translateZ(0)" }} // Safari paint fix
            >


                {/* Header Main Container */}
                <div className="h-[60px] px-4 lg:pr-4 flex items-center justify-between">
                    {/* Logo (Desktop) */}
                    <div className="hidden lg:flex items-left">
                        <RouterLink to="/">
                            <img
                                // src="https://d1lfl311x81a6w.cloudfront.net/products/1730092773960.png"
                                src="/logo.png"
                                alt="Logo"
                                loading="lazy"
                                className="h-[90px] object-contain"
                                width="160"
                                height="90"
                            />
                        </RouterLink>
                    </div>

                    {/* NavLinks (Desktop Center) */}
                    <nav className="flex-1 hidden lg:flex justify-center overflow-x-auto hide-scrollbar mx-2">
                        <NavLinks />
                    </nav>

                    {/* Desktop Icons (User, Cart, Wishlist) */}
                    <div className="hidden lg:flex items-center text-gray-600 text-lg">
                        {!searchVisible && (
                            <IoIosSearch className="h-6 w-6 cursor-pointer" onClick={() => setSearchVisible(true)} />
                        )}
                        <RouterLink to="/supportFAQ" className="text-gray-600 mx-2">
                            <PiPhoneCallLight className="h-6 w-6" />
                        </RouterLink>

                        {/* Chakra User Menu */}
                        <UserMenu
                            userInfo={userInfo}
                            userMenuItems={userMenuItems}
                            handleCouponsClick={handleCouponsClick}
                            handleLogout={handleLogout}
                        />

                        {/* Cart and Wishlist */}
                        <IconLink icon={AiOutlineShoppingCart} to="/cart" badgeCount={userInfo ? totalCartItems : localCartCount} />
                        <IconLink icon={AiOutlineHeart} to="/wishlist" badgeCount={userInfo ? wishlistItems?.length || 0 : localWishlistCount} />
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                        </button>

                        {/* {!userInfo && !searchVisible && (
                            <IoIosSearch className={`h-6 w-6 cursor-pointer text-gray-500 ${userInfo ? "" : "ml-2"}`} onClick={() => setSearchVisible(true)} />
                        )} */}
                    </div>

                    {/* Centered Mobile Logo */}
                    <div className="lg:hidden absolute left-1/2 transform -translate-x-1/2">
                        <RouterLink to="/" className="flex items-center justify-center">
                            <img
                                src="/logo.png"
                                alt="Logo"
                                loading="lazy"
                                width="160"
                                height="90"
                                className="h-[90px] object-contain" // Adjust height as needed
                            />
                        </RouterLink>
                    </div>


                    {/* Mobile Icons */}
                    <div className="flex lg:hidden items-center">
                        {!searchVisible && (
                            <IoIosSearch className={`h-6 w-6 cursor-pointer text-gray-500`} onClick={() => setSearchVisible(true)} />
                        )}
                        {/* <RouterLink to="/supportFAQ" className={`mx-2 text-sm font-bold text-gray-500`}>
                            <PiPhoneCallLight className="h-6 w-6" />
                        </RouterLink> */}

                        {/* {userInfo ? (
                            <>
                                <IconLink icon={AiOutlineShoppingCart} to="/cart" badgeCount={totalCartItems} />
                            </>
                        ) : (
                            <UserMenu
                                userInfo={null}
                                userMenuItems={[]}
                            />
                        )} */}

                        <IconLink icon={AiOutlineShoppingCart} to="/cart" badgeCount={userInfo ? totalCartItems : localCartCount} />
                        <IconLink icon={AiOutlineHeart} to="/wishlist" badgeCount={userInfo ? wishlistItems?.length || 0 : localWishlistCount} />
                    </div>
                </div>

                {/* Search Box (all viewports) */}
                {searchVisible && (
                    <div className="w-full px-6 pb-4 flex items-center justify-center">
                        <SearchBox searchVisible={searchVisible} setSearchVisible={setSearchVisible} />
                        <GrClose
                            className="ml-2 h-4 w-4 cursor-pointer text-red-500"
                            onClick={() => setSearchVisible(false)}
                        />
                    </div>
                )}
            </header>

            {/* Mobile */}

            < Transition.Root show={mobileMenuOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={setMobileMenuOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-500"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-500"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-70 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="-translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="-translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-full">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                            <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
                                                <div className="flex items-center justify-between">
                                                    <Dialog.Title className="w-full">
                                                        <div className="flex w-full flex-col">
                                                            <RouterLink
                                                                to={"/"}
                                                                onClick={() => setMobileMenuOpen(false)}
                                                                className="flex w-full"
                                                            >
                                                                <span className="sr-only">Your Company</span>
                                                                <img
                                                                    className="h-[90px]"
                                                                    // src="https://d1lfl311x81a6w.cloudfront.net/products/1730092773960.png"
                                                                    src="/logo.png"
                                                                    alt="logo"
                                                                    loading="lazy"
                                                                    width="200"
                                                                    height="90"
                                                                />
                                                            </RouterLink>
                                                        </div>
                                                    </Dialog.Title>
                                                    <div className="ml-3 flex h-8 items-center">
                                                        <button
                                                            type="button"
                                                            className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                                            onClick={() => setMobileMenuOpen(false)}
                                                        >
                                                            <span className="absolute -inset-0.5" />
                                                            <span className="sr-only">Close panel</span>
                                                            <GrClose className="h-6 w-6" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="mt-4">
                                                    {loading ? (
                                                        <div></div>
                                                    ) : error ? (
                                                        <Message type="error">{error}</Message>
                                                    ) : (
                                                        <div className="flow-root">
                                                            {userInfo?._id ? (
                                                                <Disclosure>
                                                                    {({ open }) => (
                                                                        <>
                                                                            <Disclosure.Button className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                <div className="flex w-full items-center gap-2">
                                                                                    <span className="text-base font-semibold uppercase">
                                                                                        Profile
                                                                                    </span>
                                                                                </div>
                                                                                <MdExpandLess
                                                                                    className={`${open ? "" : "rotate-180 transform"
                                                                                        } h-5 w-5 text-gray-800`}
                                                                                />
                                                                            </Disclosure.Button>
                                                                            <Disclosure.Panel>
                                                                                <div className="w-full">
                                                                                    <div className="mx-auto w-full bg-white">
                                                                                        <div className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                            <RouterLink
                                                                                                to={`/orders`}
                                                                                                onClick={() => setMobileMenuOpen(false)}
                                                                                                className="flex w-full items-center gap-2"
                                                                                            >
                                                                                                <span className="text-base font-semibold uppercase">
                                                                                                    My Orders
                                                                                                </span>
                                                                                            </RouterLink>
                                                                                        </div>
                                                                                        <div className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                            <RouterLink
                                                                                                to={`/my-warranty-claims`}
                                                                                                onClick={() => setMobileMenuOpen(false)}
                                                                                                className="flex w-full items-center gap-2"
                                                                                            >
                                                                                                <span className="text-base font-semibold uppercase">
                                                                                                    Warranty Claims
                                                                                                </span>
                                                                                            </RouterLink>
                                                                                        </div>
                                                                                        <div className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                            <RouterLink
                                                                                                to={`/addresses`}
                                                                                                onClick={() => setMobileMenuOpen(false)}
                                                                                                className="flex w-full items-center gap-2"
                                                                                            >
                                                                                                <span className="text-base font-semibold uppercase">
                                                                                                    Address
                                                                                                </span>
                                                                                            </RouterLink>
                                                                                        </div>
                                                                                        <div className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                            <RouterLink
                                                                                                to={`/profile`}
                                                                                                onClick={() => setMobileMenuOpen(false)}
                                                                                                className="flex w-full items-center gap-2"
                                                                                            >
                                                                                                <span className="text-base font-semibold uppercase">
                                                                                                    Manage Account
                                                                                                </span>
                                                                                            </RouterLink>
                                                                                        </div>
                                                                                        <div className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                            <RouterLink
                                                                                                onClick={logoutHandler}
                                                                                                className="flex w-full items-center gap-2"
                                                                                            >
                                                                                                <span className="text-base font-semibold uppercase">
                                                                                                    Logout
                                                                                                </span>
                                                                                            </RouterLink>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </Disclosure.Panel>
                                                                        </>
                                                                    )}
                                                                </Disclosure>
                                                            ) : (
                                                                <Disclosure>
                                                                    {({ open }) => (
                                                                        <>
                                                                            <Disclosure.Button className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                                <div className="flex w-full items-center gap-2">
                                                                                    <RouterLink
                                                                                        to={"/signup"}
                                                                                        onClick={() => setMobileMenuOpen(false)} className="text-base font-semibold uppercase">
                                                                                        SIGN-IN
                                                                                    </RouterLink>
                                                                                </div>
                                                                            </Disclosure.Button>
                                                                        </>
                                                                    )}
                                                                </Disclosure>
                                                            )}

                                                            {categories.map((menu) => (
                                                                <div key={menu.name} className="w-full">
                                                                    <div className="mx-auto w-full bg-white">
                                                                        <Disclosure>
                                                                            {({ open }) => (
                                                                                <>
                                                                                    <div className="flex w-full justify-between items-center px-3 py-3 border-t">
                                                                                        <div className="flex items-center gap-2 w-full">
                                                                                            {subcategories?.filter(cat => cat.category?._id === menu._id)?.length > 0 ? (
                                                                                                // Text navigates when clicked
                                                                                                <RouterLink
                                                                                                    to={`/product?categories=${menu._id}&menu=${menu.name}`}
                                                                                                    onClick={() => setMobileMenuOpen(false)}
                                                                                                    className="text-base font-semibold uppercase text-gray-900 hover:text-blue-600"
                                                                                                >
                                                                                                    {menu.name}
                                                                                                </RouterLink>
                                                                                            ) : (
                                                                                                <RouterLink
                                                                                                    to={`/product?categories=${menu._id}&menu=${menu.name}`}
                                                                                                    onClick={() => setMobileMenuOpen(false)}
                                                                                                    className="text-base font-semibold uppercase text-gray-900 hover:text-blue-600"
                                                                                                >
                                                                                                    {menu.name}
                                                                                                </RouterLink>
                                                                                            )}
                                                                                        </div>

                                                                                        {/* Dropdown toggle icon only renders if there are subcategories */}
                                                                                        {subcategories?.filter(cat => cat.category?._id === menu._id)?.length > 0 && (
                                                                                            <Disclosure.Button className="p-2">
                                                                                                <MdExpandLess
                                                                                                    className={`h-5 w-5 text-gray-800 transition-transform duration-200 ${open ? '' : 'rotate-180'
                                                                                                        }`}
                                                                                                />
                                                                                            </Disclosure.Button>
                                                                                        )}
                                                                                    </div>
                                                                                    {subcategories.length > 0 && (
                                                                                        <Disclosure.Panel>
                                                                                            <div className="grid grid-cols-3 sm: grid-cols-2 gap-x-8 gap-y-4 p-2">
                                                                                                {[...subcategories]
                                                                                                    ?.filter(
                                                                                                        (cat) =>
                                                                                                            cat.category?._id ===
                                                                                                            menu._id
                                                                                                    )
                                                                                                    ?.map((submenu) => (
                                                                                                        <RouterLink
                                                                                                            to={`/product?categories=${menu._id}&subcategories=${submenu._id}`}
                                                                                                            onClick={() =>
                                                                                                                setMobileMenuOpen(false)
                                                                                                            }
                                                                                                            className="flex flex-col gap-3 w-full items-center"
                                                                                                        >
                                                                                                            <img
                                                                                                                src={submenu?.image}
                                                                                                                alt={submenu.name}
                                                                                                                loading="lazy"
                                                                                                            />
                                                                                                            <h3 className="text-[10px] text-center font-semibold uppercase">
                                                                                                                {submenu.name}
                                                                                                            </h3>
                                                                                                        </RouterLink>
                                                                                                    ))}
                                                                                            </div>
                                                                                        </Disclosure.Panel>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </Disclosure>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            <Disclosure>
                                                                {({ open }) => (
                                                                    <>
                                                                        <Disclosure.Button className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t">
                                                                            <div className="flex w-full items-center gap-2">
                                                                                <span className="text-base font-semibold uppercase">
                                                                                    Collections
                                                                                </span>
                                                                            </div>
                                                                            <MdExpandLess
                                                                                className={`${open ? "" : "rotate-180 transform"
                                                                                    } h-5 w-5 text-gray-800`}
                                                                            />
                                                                        </Disclosure.Button>
                                                                        <Disclosure.Panel>
                                                                            <div className="grid grid-cols-3 sm:grid-cols-2 gap-x-8 gap-y-4 p-2">
                                                                                {collections?.map((submenu) => (
                                                                                    <RouterLink
                                                                                        to={`/product?collections=${submenu._id}`}
                                                                                        onClick={() => setMobileMenuOpen(false)}
                                                                                        className="flex flex-col gap-3 w-full items-center"
                                                                                    >
                                                                                        <img
                                                                                            src={submenu?.image}
                                                                                            alt={submenu.name}
                                                                                            loading="lazy"
                                                                                        />
                                                                                        <h3 className="text-[10px] text-center font-semibold uppercase">
                                                                                            {submenu.name}
                                                                                        </h3>
                                                                                    </RouterLink>
                                                                                ))}
                                                                            </div>
                                                                        </Disclosure.Panel>
                                                                    </>
                                                                )}
                                                            </Disclosure>

                                                            <RouterLink
                                                                to={`/product?isLatestArrival=true&menu=WHATS%20NEW`}
                                                                onClick={() => setMobileMenuOpen(false)}
                                                                className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t"
                                                            >
                                                                <div className="flex w-full items-center gap-2">
                                                                    <span className="text-base font-semibold uppercase">
                                                                        What's New
                                                                    </span>
                                                                </div>
                                                            </RouterLink>

                                                            <RouterLink
                                                                to={`/product?gender=male&menu=FOR%20HIM`}
                                                                onClick={() => setMobileMenuOpen(false)}
                                                                className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t"
                                                            >
                                                                <div className="flex w-full items-center gap-2">
                                                                    <span className="text-base font-semibold uppercase">
                                                                        For Him
                                                                    </span>
                                                                </div>
                                                            </RouterLink>

                                                            <RouterLink
                                                                to={`/supportFAQ`}
                                                                onClick={() => setMobileMenuOpen(false)}
                                                                className="flex w-full justify-between items-center px-3 py-3 text-left text-sm font-medium text-gray-900 focus:text-blue-600 border-t"
                                                            >
                                                                <div className="flex w-full items-center gap-2">
                                                                    <span className="flex items-center gap-2 text-base font-semibold uppercase">
                                                                        <PiPhoneCallLight className="h-6 w-6 flex-shrink-0 text-gray-500" />
                                                                        Contact Us
                                                                    </span>
                                                                </div>
                                                            </RouterLink>

                                                            <div className="flex w-full justify-between items-center px-3 py-3 text-left text-[10px] font-medium text-gray-500 focus:text-blue-600 border-t">
                                                                <div className="flex w-full items-center gap-2">
                                                                    <span className="flex items-center gap-2 font-semibold uppercase text-[12px]">
                                                                        © {new Date().getFullYear()} Soradis Jewellers Private Limited.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root >

            {/* Drawer */}
            < Drawer isOpen={isOpen} placement="right" onClose={onClose} >
                <DrawerOverlay />
                <DrawerContent className="w-full sm:w-[600px] max-w-full">
                    <DrawerCloseButton />
                    <DrawerHeader>Coupons</DrawerHeader>
                    <DrawerBody>
                        <CouponCard />
                    </DrawerBody>
                </DrawerContent>
            </Drawer >

        </div >
    );
};

export default NewHeader;
